<form>
    <ui-signal-form-select [formField]="form.stCode"
                           [bindValue]="'stCode'"
                           [clearable]="false"
                           [label]="'global.labels.status' | translate"
                           [options]="statuses$ | async" />
</form>

<ui-dialog-actions>
    <ui-button
        [square]="true"
        [loading]="pending"
        [disabled]="form().invalid() || pending || !form().dirty()"
        [label]="'global.actions.confirm' | translate"
        (handlerClick)="handlerConfirm()" />
</ui-dialog-actions>
